const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
};

const formatRequestOptions = (data, method = 'POST') => {
  const csrfToken = getCsrfToken();
  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json',
    },
    body: data ? JSON.stringify(data) : null,
  };
};

const returnFetchPromise = (url, data, method = 'POST') => {
  const requestOptions = formatRequestOptions(data, method);
  return fetch(url, requestOptions);
};

// Request password reset email
export const requestPasswordReset = async (email) => {
  try {
    const response = await fetch('/api/v1/password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user: { email } }),
    });

    // If the response is not JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Server error: please try again later');
    }

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    }

    return { success: false, error: data.error || 'An error occurred' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Submit new password (with token)
export const submitNewPassword = async ({
  password, passwordConfirmation, token, confirmationToken, invitation,
}) => {
  try {
    const body = {
      user: {
        password,
        password_confirmation: passwordConfirmation,
        reset_password_token: token,
      },
    };

    if (confirmationToken) {
      body.user.confirmation_token = confirmationToken;
    }

    if (invitation) {
      // Enables invitation-specific token window on the backend.
      body.user.invitation = true;
    }

    const response = await returnFetchPromise('/api/v1/password', body, 'PUT');

    const json = await response.json();

    if (response.ok && json.success) {
      return { success: true, email: json.email };
    }

    return { success: false, error: json?.error || 'Failed to reset password.' };
  } catch (err) {
    return { success: false, error: err.message };
  }
};

export const validateResetPasswordToken = async ({ token, invitation = false }) => {
  try {
    const body = {
      user: {
        reset_password_token: token,
        // Backend uses this flag to apply invitation TTL instead of forgot-password TTL.
        invitation,
      },
    };
    const response = await returnFetchPromise('/api/v1/password/validate_token', body, 'POST');

    const json = await response.json();

    if (response.ok && json.valid) {
      return { success: true };
    }

    return { success: false, reason: json.reason, errors: json.errors };
  } catch (err) {
    return { success: false, errors: [err.message] };
  }
};
